import styled from 'styled-components';

import { ReactComponent as StreakRepairIcon } from 'src/images/svgs/streak-repair.svg';

export const StyledRecordItemWrapper = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.gradientDark};
  border-radius: ${({ theme }) => theme.radius.small};
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.8rem 1rem;
  padding: 1.6rem 2.4rem;
  height: 9.4rem;

  svg {
    height: 2.4rem;
    path {
      fill: ${({ theme }) => theme.colors.primary.main};
    }
  }

  &[data-type='points'] {
    svg path {
      fill: ${({ theme }) => theme.colors.warning.main};
    }
  }

  p,
  span {
    color: ${({ theme }) => theme.colors.white};
    margin: 0;
  }
`;

export const StyledRecordTitle = styled.p`
  grid-column: 1 / -1;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  min-width: 10.9rem;
`;

export const StyledAvatar = styled.div`
  position: relative;
`;

export const StyledCircleCheck = styled.span`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.primary.main};
  border-radius: 100%;
  bottom: 0;
  display: flex;
  justify-content: center;
  position: absolute;
  right: 0;
  height: 4.3rem;
  width: 4.3rem;

  svg {
    height: 2.4rem;
    path {
      fill: ${({ theme }) => theme.colors.secondary.main};
    }
  }
`;

export const StyledStaticsContent = styled.span`
  font-size: 2.4rem;
  ::first-letter {
    text-transform: uppercase;
  }
`;

export const StyledRedeemTicketsWrapper = styled.div`
  margin-bottom: 2rem;
`;

export const StyledStreakRepairIcon = styled(StreakRepairIcon)<{ $isDarkMode: boolean }>`
  width: 3.6rem;
  height: 3.6 rem;
  .flame-top {
    fill: ${({ $isDarkMode }) => !$isDarkMode && '##FF8D001A'};
  }
`;

export const StyledStreakRepairText = styled.div<{ $isDarkMode: boolean }>`
  color: ${({ theme, $isDarkMode }) => ($isDarkMode ? theme.colors.white : '#151c2b')};
  p {
    font-size: 2rem;
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
  }
  span {
    font-size: 1.6rem;
  }
`;

export const StyledLeagueNotification = styled.div`
  align-items: center;
  display: flex;
  gap: 1.6rem;
  padding: 1.6rem;
  margin-top: 1.6rem;
  min-height: 6.1rem;
`;

export const StyledLeagueIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 5.2rem;
  height: 6.1rem;

  svg {
    width: 100%;
    height: 100%;
    opacity: 0.7;
  }
`;

export const StyledLeagueContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  flex: 1;
`;

export const StyledLeagueTitle = styled.p`
  color: ${({ theme }) => theme.colors.text.main};
  font-size: 2rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  margin: 0;
  text-align: center;
  line-height: 1.25;
`;
